module.exports = __webpack_public_path__ + "img/MarketTransactionIcon.6972a041.svg";